import {
  HORIZONTAL_TABLE_ADD,
  HORIZONTAL_TABLE_REMOVE,
  HORIZONTAL_TABLE_UPDATE,
  HORIZONTAL_TABLE_NESTED_ADD,
  HORIZONTAL_TABLE_NESTED_REMOVE,
  HORIZONTAL_TABLE_NESTED_UPDATE
}from './constants'

// TODO: rename colKey -> element
const horizontalTableAdd = () => ({ type: HORIZONTAL_TABLE_ADD })
const horizontalTableRemove = (index) => ({ type: HORIZONTAL_TABLE_REMOVE, index})
const horizontalTableUpdate = (index, element, value) => ({ type: HORIZONTAL_TABLE_UPDATE, index, element, value })

const horizontalTableNestedAdd = (colKey, horizontalTableIndex) => ({ type: HORIZONTAL_TABLE_NESTED_ADD, colKey, horizontalTableIndex })
const horizontalTableNestedRemove = (horizontalTableIndex, colKey, verticalTableIndex) => ({ type: HORIZONTAL_TABLE_NESTED_REMOVE, horizontalTableIndex, colKey, verticalTableIndex})
const horizontalTableNestedUpdate = (horizontalTableIndex, colKey, verticalTableIndex, nestedColKey, value) => ({ type: HORIZONTAL_TABLE_NESTED_UPDATE, horizontalTableIndex, colKey, verticalTableIndex, nestedColKey, value })

export {
  horizontalTableAdd,
  horizontalTableRemove,
  horizontalTableUpdate,
  horizontalTableNestedAdd,
  horizontalTableNestedRemove,
  horizontalTableNestedUpdate
}